export default "__VITE_ASSET__zf0IAuK1__"